import { useEffect, useMemo, useState } from "react";

import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    List,
    ListItemButton,
    ListItemText,
    TextField,
    Typography
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import SearchIcon from "@mui/icons-material/Search";

const AddCollegeModal = ({
    open,
    onClose,
    colleges,
    onSelect
}) => {

    const [search, setSearch] = useState("");

    useEffect(() => {

        if (!open) {
            setSearch("");
        }

    }, [open]);

    const filteredColleges = useMemo(() => {

        return colleges.filter(college =>
            college.name
                .toLowerCase()
                .includes(search.toLowerCase())
        );

    }, [search, colleges]);

    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden"
                }
            }}
        >

            {/* HEADER */}

            <DialogTitle
                sx={{
                    backgroundColor: "#002147",
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1.5,
                    px: 2
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1
                    }}
                >

                    <SchoolIcon />

                    <Typography
                        sx={{
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            fontSize: "1rem"
                        }}
                    >
                        Select College
                    </Typography>

                </Box>

                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        color: "#fff"
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>

            </DialogTitle>

            {/* CONTENT */}

            <DialogContent
                sx={{
                    p: 2,
                    mt: 1
                }}
            >

                {/* SEARCH */}

                <TextField
                    fullWidth
                    placeholder="Search college..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    variant="outlined"
                    size="small"
                    sx={{
                        mb: 2,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            fontFamily: "Poppins"
                        }
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon sx={{ color: "#666" }} />
                            </InputAdornment>
                        )
                    }}
                />

                {/* COUNT */}

                {/* <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1.5
                    }}
                >

                    <Chip
                        label={`${filteredColleges.length} Colleges`}
                        size="small"
                        sx={{
                            backgroundColor: "#00214715",
                            color: "#002147",
                            fontWeight: 600,
                            fontFamily: "Poppins"
                        }}
                    />

                </Box> */}

                {/* LIST */}

                <List
                    sx={{
                        maxHeight: 450,
                        overflow: "auto",
                        border: "1px solid #eee",
                        borderRadius: 2,
                        p: 0
                    }}
                >

                    {filteredColleges.length === 0 ? (

                        <Box
                            sx={{
                                py: 5,
                                textAlign: "center"
                            }}
                        >

                            <Typography
                                sx={{
                                    color: "#666",
                                    fontFamily: "Poppins"
                                }}
                            >
                                No colleges found
                            </Typography>

                        </Box>

                    ) : (

                        filteredColleges.map((college, index) => (

                            <ListItemButton
                                key={college.code}
                                onClick={() => onSelect(college.code)}
                                sx={{
                                    py: 1.5,
                                    px: 2,
                                    borderBottom:
                                        index !== filteredColleges.length - 1
                                            ? "1px solid #f3f3f3"
                                            : "none",
                                    transition: "0.2s",

                                    "&:hover": {
                                        backgroundColor: "#00214710"
                                    }
                                }}
                            >

                                <ListItemText
                                    primary={college.name}
                                    secondary={`Code: ${college.code}`}
                                    primaryTypographyProps={{
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "0.95rem"
                                    }}
                                    secondaryTypographyProps={{
                                        fontFamily: "Poppins",
                                        fontSize: "0.8rem",
                                        color: "#777"
                                    }}
                                />

                            </ListItemButton>

                        ))

                    )}

                </List>

            </DialogContent>

        </Dialog>
    );
};

export default AddCollegeModal;